<!------------------------------------------------------------------------------
 File: BaseIconButton 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 26/10/2018
 Time: 11:19
------------------------------------------------------------------------------->
<template>
    <component
        v-if="tag_name == 'a'"
        :is="tag_name"
        :href="link()"
        :class="[ theme,{
            'btn-floating':float === true
        } ]"
        class="btn"
        role="button"
    >
        <BaseIcon
            :class="icon.cls"
            :content="icon.content"></BaseIcon>
    </component>
    <component
        v-else
        v-on:click="click_event()"
        :is="tag_name"
        :class="[ theme,{
            'btn-floating':float === true
        } ]"
        class="btn"
        role="button"
    >
        <BaseIcon
            :class="icon.cls"
            :content="icon.content"></BaseIcon>
    </component>
</template>

<script>
    export default {
        name: 'BaseIconButton',
        components: {},
        props: {
            float:{
                type:Boolean,
                default:false
            },
            route: {
                type: String
            },
            tag_name: {
                type: String,
                default: 'a'
            },
            theme: {
                type: String,
                default: 'btn-primary'
            },
            icon: {
                cls:{
                    type: String,
                    default: 'material-icons'
                },
                content:{
                    type: String,
                    default: 'settings'
                }
            },

        },
        created() {},
        destroyed() {},
        mounted() {

        },
        data() {
            return {};
        },
        methods: {
            link() {
                return (
                    this.tag_name == 'a'
                ) ? this.route : null;
            },
            click_event(){
                this.$emit('click_event')
            }
        },
        watch: {},
        computed: {}
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/base/BaseIconButton.vue?169f9b98